import {BackButton} from "../../atom/BackButton";
import styles from './Questionnaire.module.scss'
import IconList from "../../component/IconList/IconList";

export default function Questionnaire({question, icons}) {

  return (
      <div className={styles.Questionnaire}>
        <h2 className={styles.QuestionnaireHeadline}>{question}</h2>
        <div className={styles.HomeIcons}>
          <IconList icons={icons}></IconList>
        </div>

        <div className={styles.QuestionnaireBack}>
            <BackButton />
        </div>
      </div>
  );
}